module.exports = __webpack_public_path__ + "img/kk50th.926d09e1.png";